import React, { useEffect, useState, useContext } from "react";
import { useNavigate, useLocation, useParams, Outlet } from "react-router-dom";
import {
	ContentContainer,
	ContentGroup,
	createDialog,
	QuestionDialog,
} from "coaz-ui";
import { PiChalkboardTeacherLight, PiStudentLight } from "react-icons/pi";
import { GlobalContext } from "../contexts/GlobalContext";
import client from "../client";
import LoadingIcons from "react-loading-icons";
import Card from "./Card";
import ResponsiveChildren from "./ResponsiveChildren";

const Teacher = () => {
	const { version, setVersion } = useContext(GlobalContext);
	const [user,setUser] = useState(null);
	const [teaching, setTeaching] = useState([]);
	const [availableCpds, setAvailableCpds] = useState([]);
	const [loading, setLoading] = useState(true);

	const { cpdId } = useParams();
	const navigate = useNavigate();
	const path = useLocation().pathname;
	const { request, getCurrent, errorMessage } = client;

	const load = async () => {
		setLoading(true);

		let currentUser = null;

		try {
			currentUser = await getCurrent();
		} catch (error) {
			console.log(error);
			return;
		}

		if (!currentUser && !currentUser.user) return;

		setUser(currentUser.user);

		let current = [];

		try {
			current = await request("GET", "teachers/by-user", null, {userReference: currentUser.user.ref.value,})
		} catch (error) {
			console.log(error);
		}

		let available = [];

		try {
			available = await request("GET", "teachers/available", null, {userReference: currentUser.user.ref.value,});
		} catch (error) {
			console.log(error);
		}

		setTeaching(current);
		setAvailableCpds(available);
		setLoading(false);
	};

	const onOpen = (e,id) => {
		e.preventDefault();
		e.stopPropagation();
		if(!id) return;
		navigate(`${path}/_teach/${id}`)
	};

	const onTeach = (e,id) => {
		e.preventDefault();
		e.stopPropagation();
		if(!id) return;
		createDialog({
			title: "Teach",
			submitText: "Yes",
			cancelText: "No",
			Component: QuestionDialog,
			params: {
				message: `Are you sure you want to start teaching this cpd?`,
				submit: async () => {
					try {
						await request("POST", "teachers", null, {
							userReference:user.ref.value,
							cpdId: id,
						});
						return { message: "Successful", success: true };
					} catch (error) {
						return { message: errorMessage(error) };
					}
				},
			},
			version: version,
			setVersion: setVersion,
		});
	};

	const onStop = (e,id) => {
		e.preventDefault();
		e.stopPropagation();
		if(!id) return;
		createDialog({
			title: "Stop Teaching",
			submitText: "Yes",
			cancelText: "No",
			Component: QuestionDialog,
			params: {
				message: `Are you sure you want to stop teaching this cpd?`,
				submit: async () => {
					try {
						await request("DELETE", "teachers", null, {
							userReference:user.ref.value,
							cpdId: id,
						});
						return { message: "Successful", success: true };
					} catch (error) {
						return { message: errorMessage(error) };
					}
				},
			},
			version: version,
			setVersion: setVersion,
		});
	};

	useEffect(() => {
		load();
	}, [version]);

	if (cpdId) return <Outlet />;

	return (
		<ContentContainer
			Icon={PiChalkboardTeacherLight}
			text={`${user?.firstname ?? ""} ${user?.lastname ?? ""}`}
			scrollable={true}
			loading={loading}
		>
			<div className="flex flex-col space-y-4">
				{teaching.length > 0 && (
					<ContentGroup name="Teaching">
						<ResponsiveChildren>
							{teaching.map((class_, index) => (
								<Card
									key={class_?.cpd?.ref?.id ?? index}
									id={class_?.cpd?.ref?.id ?? index}
									heading={class_?.cpd?.name}
									body={class_?.cpd?.description}
									image={`${process.env.PUBLIC_URL}/images/teacher.jpg`}
									onOpen={onOpen}
									actionText="Stop teaching..."
									onAction={onStop}
								/>
							))}
						</ResponsiveChildren>
					</ContentGroup>
				)}

				{availableCpds.length > 0 && (
					<ContentGroup name="Available Cpds">
						<ResponsiveChildren>
							{availableCpds.map((cpd, index) => (
								<Card
									key={cpd.ref?.id ?? index}
									id={cpd.ref?.id ?? index}
									heading={cpd.name}
									body={cpd.description}
									image={`${process.env.PUBLIC_URL}/images/cpd.jpg`}
									actionText="Start teaching..."
									onAction={onTeach}
								/>
							))}
						</ResponsiveChildren>
					</ContentGroup>
				)}
			</div>
		</ContentContainer>
	);
};

export default Teacher;
